import {
  GET_PRONTO_PROVIDER_STATUS_REQUEST,
  CREATE_PRONTO_PROVIDER_REQUEST,
  GET_USER_INFO_REQUEST,
} from "./constants";

export function getProntoProviderStatus() {
  return { type: GET_PRONTO_PROVIDER_STATUS_REQUEST };
}

export function createProntoProviderRequest() {
  return { type: CREATE_PRONTO_PROVIDER_REQUEST };
}

export function getInstallerInfo() {
  return { type: GET_USER_INFO_REQUEST };
}
